import { PlusOutlined } from '@ant-design/icons';
import { CssColors } from 'src/styles/CssVariables';
import styled from 'styled-components';

export const PlusButton = (
    props: React.ButtonHTMLAttributes<HTMLButtonElement>,
) => {
    return (
        <StyledCreateButton {...props}>
            <PlusOutlined />
        </StyledCreateButton>
    );
};

const StyledCreateButton = styled.button`
    width: 3.6rem;
    min-width: 3rem;
    font-weight: 700;
    height: 2.4rem;
    margin-left: 0.8rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    height: 2rem;
    border: none;
    background: ${CssColors.black};
    border-radius: 0.35rem;
    color: #ffffff;
    span: {
        font-size: 1rem;
    }
`;
